// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"a17258e7","977":"b2f7a2e0"}[chunkId] + ".chunk.js";
};